import React from "react";
import Markdown from "./Markdown";

function App() {
  return (
    <>
      <h1 className="title">MARKDOWN PREVIEW</h1>
      <div className="App">
        <Markdown />
      </div>
    </>
  );
}

export default App;
